<template>
  <div id="Demographics" class="section">
    <div class="box">
      <h1 class="title">Socio-demographic performa</h1>
      <div>Fields with <b>'*'</b> indicate mandatory fields</div>
      <br />
      <div v-if="isLoading">
        Loading...
        <i class="fa fa-spinner fa-2x"></i>
      </div>
      <div v-else>
        <div v-for="(demographicQues, qIndex) in demographicQues">
          <div class="is-size-6">
            <b><span v-if="isMandatoryField(qIndex)">*</span>{{ demographicQues.question }}</b>
          </div>
          <div class="columns is-multiline">
            <div class="column is-3 is-outlined" v-for="(option, index) in demographicQues.options">
              <div v-if="option !== 'Text'">
                <a class="button" :id="`${qIndex}Res${index}`" v-on:click="updateOption(index, qIndex)">{{ option }}</a>
              </div>
              <div v-else>
                <div class="control">
                  <input class="input" type="text" @keyup="updateText(index, qIndex, $event.target.value)" />
                </div>
                <div class="is-danger help" v-if="questionIndex === qIndex">{{ errors[qIndex] }}</div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <SessionInfo />
        <br />
        <button class="button is-large is-info" :class="{ 'is-loading': isLoadingSubmit }" @click="sendRequest()" :disabled="isResponseSubmitted">Submit</button>
        &nbsp; &nbsp; <button v-if="isResponseSubmitted" class="button is-large is-info" @click="next()">Next &gt;&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
import SessionInfo from './SessionInfo';

export default {
  name: 'Demographics',
  components: {
    SessionInfo,
  },
  data() {
    return {
      isLoading: true,
      isLoadingSubmit: false,
      isResponseSubmitted: false,
      demographicQues: [],
      questionIndex: 0,
      responses: [],
      testId: { english: 1, tamil: 4, hindi: 5 },
      options: [],
      errors: [],
      language: 'english', // default
    };
  },
  methods: {
    next() {
      this.$router.push('/tests/English');
      console.log(this.responses);
    },
    isMandatoryField(qIndex) {
      // 1st 4 are mandatory
      for (let i = 0; i < 4; i += 1) {
        if (qIndex === i) {
          return true;
        }
      }
      return false;
    },
    updateOption(index, qIndex) {
      if (this.options[qIndex] !== undefined) {
        const prevOption = this.options[qIndex];
        console.log('prev option : ', prevOption);
        document.getElementById(`${qIndex}Res${prevOption}`).classList.remove('active');
      }
      document.getElementById(`${qIndex}Res${index}`).classList.add('active');
      this.responses[qIndex] = { idx: index };
      this.options[qIndex] = index;
    },
    isFieldsValid(value) {
      const qInfo = JSON.parse(this.demographicQues[this.questionIndex].qInfo);
      // debugger;
      // no validation (i.e. fields valid by default) if qInfo is not given (null, undefined or '')
      if (!!qInfo === false) {
        return true;
      }
      const vObj = new RegExp(qInfo.vReg);
      const isValid = vObj.test(value);
      console.log('isValid:', vObj, value, isValid);
      if (isValid) {
        this.errors.splice(this.questionIndex, 1, '');
        return true;
      }

      this.errors.splice(this.questionIndex, 1, qInfo.err);
      return false;
    },
    updateText(index, qIndex, value) {
      this.questionIndex = qIndex;
      this.isFieldsValid(value);
      this.responses[qIndex] = { text: value };
    },
    isEmpty(value) {
      return value === undefined || value === '';
    },
    isResponseCompleted() {
      for (let i = 0; i < 4; i += 1) {
        this.questionIndex = i;
        if (this.responses[i] === undefined) {
          return false;
        }
        if (!this.isFieldsValid(this.responses[i].text)) {
          return false;
        }
      }
      return true;
    },
    setResponseNotSaved() {
      for (let i = 4; i <= 7; i += 1) {
        if (this.isEmpty(this.responses[i])) {
          this.responses[i] = { idx: -1 };
        }
      }
    },
    sendRequest() {
      console.log(this.responses);
      if (this.responses.length < 4 || !this.isResponseCompleted()) {
        this.$toast.open('Please fill ALL mandatory fields indicated by "*"');
        return;
      }
      this.setResponseNotSaved();
      this.isLoadingSubmit = true;
      this.$http
        .post('/scarf/submitAnswers', {
          sessionCode: this.$temp.sessionCode,
          testId: this.testId[this.language],
          responses: this.responses,
        })
        .then((res) => {
          this.isLoadingSubmit = false;
          if (res.data.ok === 1) {
            this.$toast.open(res.data.msg);
            this.isResponseSubmitted = true;
          } else {
            this.$toast.open(res.data.msg);
            this.isResponseSubmitted = false;
          }
        });
    },
    checkSessionAndInit() {
      if (this.$temp.sessionCode) {
        this.getDemoQuestions();
      } else {
        this.$toast.open('Your session ended. Enter your organization code and try again.');
        this.$router.push('/');
      }
    },
    getDemoQuestions() {
      console.log('qId', this.language, this.testId[this.language]);
      this.$http
        .get('/scarf/getQuestions', {
          params: {
            qId: this.testId[this.language],
          },
        })
        .then((res) => {
          console.log('ques:', res.data);
          this.isLoading = false;
          this.demographicQues = res.data.questions;
        });
    },
  },
  watch: {
    option(value) {
      this.isFieldsValid(value);
    },
  },
  created() {
    window.scroll(0, 0);
    this.language = this.$route.params.language;
    console.log('language', this.language);
    this.checkSessionAndInit();
  },
};
</script>

<style scoped>
.active {
  background-color: #90caf9;
}
.hidden {
  display: none;
}
.section {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Demographics.vue